import React, { useCallback, useEffect, useMemo, useState } from "react";
import BreadCrumb from "Common/BreadCrumb";
// Icons
import { Search, Plus, Trash2 } from "lucide-react";
import TableContainer from "Common/TableContainer";
import { Link } from "react-router-dom";
import DeleteModal from "Common/DeleteModal";
import Modal from "Common/Components/Modal";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

import { toast, ToastContainer } from "react-toastify";
import axios from "axios";
import LoadingCounter from "Common/Components/LoadingCounterProps";

const ProductPage = () => {
  const [data, setData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [eventData, setEventData] = useState<any>();
  const [reload, setreload] = useState<boolean>();
  const [load, setload] = useState<boolean>();
  const [errorMessage, setErrorMessage] = useState("");
  // Delete Modal
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);
  const [dataListProduct, setdataListProduct] = useState<any>([]);
  const [dataListProductValue, setdataListProductValue] = useState<any>(null);
  const [YearCoptSelect, setYearCoptSelect] = useState<any>();

  const handleChange = (key: any, value: any) => {
    setdataListProductValue(value);
  };
  // Get Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "https://api.havirkesht.ir/product/?sort_by=updated_at&sort_order=desc"
        );
        const items = res?.data?.items || [];
        setData(items);
        setload(items.length < 0);
      } catch (error: any) {
        console.error("Error fetching data:", error);
        if (error) {
          setErrorMessage(
            "مشکلی در ارتباط با سرور رخ داده است. لطفاً اینترنت خود را بررسی کنید و مطمئن شوید فیلترشکن غیرفعال است."
          );
        } else {
          setErrorMessage("خطایی رخ داده است. لطفاً مجدداً تلاش کنید.");
        }
        setload(true);
      }
    };
    fetchData();
  }, [reload]);

  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell.product_name) {
      setEventData(cell.product_name);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("app_atkey");
      try {
        const response = await axios.get(
          "https://api.havirkesht.ir/measure_unit/",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setdataListProduct(response.data?.items || []);
      } catch (error) {
        console.error("خطا در دریافت داده‌ها:", error);
      }
    };

    fetchData();
  }, []);

  const handleDelete = async () => {
    if (eventData) {
      const res = await axios.delete(
        `https://api.havirkesht.ir/product/${eventData}`
      );
      if (res.status === 200) {
        toast.success("عملیات حذف با موفقیت انجام شد");
        setreload(!reload);
      } else {
        toast.error("خطایی در حذف رخ داد");
      }
      setDeleteModal(false);
      setEventData(null);
    }
  };
  const localstorageID = localStorage.getItem("crop_year_id");

  useEffect(() => {
    const featchData = async () => {
      const response = await axios.get("https://api.havirkesht.ir/crop-year/");
      const getyear = response?.data?.items?.find(
        (items: any) => items.id == localstorageID
      );
      setYearCoptSelect(getyear?.crop_year_name);
    };
    featchData();
  }, []);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    validation.handleSubmit();
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      product_name: "",
    },
    validationSchema: Yup.object({
      product_name: Yup.string().required("لطفاً کالا را وارد کنید"),
    }),
    onSubmit: async (values) => {
      if (!dataListProductValue) {
        setShow(true);
        return toast.error("لطفا مقیاس سنجش را وارد کنید");
      }
      const newData = {
        ...values,
        measure_unit_id: Number(dataListProductValue),
        crop_year_id: localstorageID,
      };

      const res = await axios.post(
        "https://api.havirkesht.ir/product/",
        newData
      );
      if (res.status === 201) {
        toast.success(`کالا جدید ثبت شد`);
        setreload(!reload);
      } else {
        toast.error(`خطا در ثبت`);
      }
      toggle();
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      validation.resetForm();
    } else {
      setShow(true);
      setEventData("");
      validation.resetForm();
    }
  }, [show, validation]);

  const columns = useMemo(
    () => [
      {
        header: "عنوان",
        accessorKey: "product_name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },

      {
        header: "سال زراعی",
        accessorKey: "crop_year_name",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },

      {
        header: "تاریخ ایجاد",
        accessorKey: "created_at",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <Link
            to="#"
            className="transition-all duration-150 ease-linear text-custom-500 hover:text-custom-600"
          >
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "عملیات",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            <Link to="#" onClick={() => onClickDelete(cell.row.original)}>
              <Trash2 className="size-4" />
            </Link>
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb pageTitle="ثبت کالا" title="هاویر کشت " />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer
        position="top-center"
        closeButton={false}
        limit={1}
        rtl={true}
        className="font-Bold text-lg"
      />
      {errorMessage && <div>{errorMessage}</div>}
      <div className="card" id="employeeTable rtl">
        <div className="card-body">
          <div className="flex items-center gap-3 mb-4">
            <h6 className="text-15 grow">
              مجموع کالا ها (<b className="total-Employs">{data?.length}</b>)
            </h6>
            <div className="shrink-0">
              <Link
                to="#"
                onClick={toggle}
                type="button"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600"
              >
                <span className="align-middle rtl">ایجاد کالا جدید</span>{" "}
                <Plus className="inline-block size-4 rtl" />
              </Link>
            </div>
          </div>
          {data && data.length > 0 ? (
            <TableContainer
              isPagination={true}
              columns={columns}
              isGlobalFilter={true}
              data={data}
              customPageSize={10}
              divclassName="-mx-5 overflow-x-auto"
              tableclassName="w-full whitespace-nowrap"
              theadclassName="ltr:text-left rtl:text-right bg-slate-100 dark:bg-zink-600"
              thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-b border-slate-200 dark:border-zink-500"
              tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
              PaginationClassName="flex flex-col items-center gap-4 px-4 mt-4 md:flex-row"
            />
          ) : (
            <LoadingCounter
              count={data ? 0 : 15}
              text={errorMessage ? errorMessage : "داده ای در جدول وجود ندارد"}
            />
          )}
        </div>
      </div>

      <Modal
        show={show}
        onHide={toggle}
        modal-center="true"
        className="fixed flex flex-col transition-all duration-300 ease-in-out left-2/4 z-drawer -translate-x-2/4 -translate-y-2/4"
        dialogClassName="w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600"
      >
        <Modal.Header
          className="flex items-center justify-between p-4 border-b dark:border-zink-500"
          closeButtonClass="transition-all duration-200 ease-linear text-slate-400 hover:text-red-500"
        >
          <Modal.Title className="text-16"> ایجادکالا جدید </Modal.Title>
        </Modal.Header>
        <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={validation.handleSubmit}
          >
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-11  dark:text-white text-gray-800 space-y-4">
                <div className="flex flex-col items-center">
                  <div className="flex pga-4  items-center">
                    <label
                      htmlFor="province"
                      className="text-base font-medium  flex-shrink-0"
                    >
                      مقیاس سنجش :
                    </label>
                    <select
                      id="province"
                      className="flex-1 p-2 border border-gray-200 w-52 mx-2 rounded bg-white text-gray-900 dark:border-gray-200"
                      onChange={(e) =>
                        handleChange("dataListProvince", e.target.value)
                      }
                    >
                      <option value="null">انتخاب کنید</option>
                      {dataListProduct?.map((data: any) => (
                        <option key={data.id} value={data.id}>
                          {data?.unit_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="flex mt-2 mr-4 items-center">
                    <label
                      htmlFor="product"
                      className="text-base font-medium mr-2 "
                    >
                      عنوان کالا:
                    </label>
                    <input
                      type="text"
                      id="product_name"
                      className="form-input w-52 mx-2 text-black font-[12px] "
                      placeholder="عنوان کالا"
                      name="product_name"
                      autoComplete="off"
                      onChange={validation.handleChange}
                      value={validation.values.product_name}
                    />
                  </div>
                </div>
                {validation.touched.product_name &&
                  validation.errors.product_name && (
                    <p className="text-red-400 mr-24 mt-2">
                      {validation.errors.product_name}
                    </p>
                  )}
              </div>
            </div>
            <div className="mt-5 mr-20">
              سال زراعی انتخاب شده:{" "}
              <span className="text-custom-600 dark:text-gray-200 bold">
                {YearCoptSelect ? YearCoptSelect : ""}{" "}
              </span>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="flex justify-center p-4 border-t dark:border-zink-500">
          <button
            type="button"
            onClick={handleClick}
            className="px-4 py-2 mt-4 font-bold justify-end text-white bg-blue-500 rounded hover:bg-blue-600"
          >
            ثبت
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ProductPage;
